var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"},on:{"drop":function($event){$event.preventDefault();},"dragover":function($event){$event.preventDefault();}}},[_c('loader-indicator'),(_vm.layout)?_c(_vm.layout,{tag:"component"},[_c('router-view')],1):_vm._e(),(!_vm.layout)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }